"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionCalendar_1 = __importDefault(require("./CollectionCalendar"));
exports.default = CollectionCalendar_1.default;
